module.exports = __webpack_public_path__ + "img/illinoisAdventure@2x.946540a8.png";